import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import OrderActions from "./OrderActions";
import { styled } from "@mui/material/styles";
import { LocationData } from "types/models/master/MasterApp";

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  padding: 8,
  minWidth:170,
  "&:first-of-type": {
    paddingLeft: 20,
  },
  "&:last-of-type": {
    paddingRight: 20,
  },
}));

interface TableItemProps {
  data: LocationData;
}

const TableItem: React.FC<TableItemProps> = ({ data }) => {
  const getStatusColor = () => {
    switch (data.status) {
      case "Active": {
        return "#43C888";
      }
      case "inactive": {
        return "#F84E4E"; 
      }
      default: {
        return "#E2A72E"; 
      }
    }
  };

  return (
    <TableRow key={data.sNo} className="item-hover">
      <StyledTableCell component="th" scope="row">
        <Box sx={{ color: "black", borderBottom: "none", display: "inline-block" }}>
          {data.sNo}
        </Box>
      </StyledTableCell>
      <StyledTableCell align="left">{data.deviceIp}</StyledTableCell>
      <StyledTableCell align="left">{data.npName}</StyledTableCell>
      <StyledTableCell align="left">{data.pinCode}</StyledTableCell>
      <StyledTableCell align="left">{data.latitude}</StyledTableCell>
      <StyledTableCell align="left">{data.longitude}</StyledTableCell>
      <StyledTableCell align="left">{data.hostName}</StyledTableCell> 
      <StyledTableCell align="left">{data.serviceVlanid}</StyledTableCell> 
      <StyledTableCell align="left">{data.nasPortId}</StyledTableCell> 
      <StyledTableCell align="left">{data.voltage}</StyledTableCell> 
      <StyledTableCell align="left">{data.switchConnectivity}</StyledTableCell> 
      <StyledTableCell align="left">{data.switchPortNo}</StyledTableCell> 
      <StyledTableCell align="left">{data.switchPortConnectivity}</StyledTableCell> 
      <StyledTableCell align="left">{data.mediaConverter}</StyledTableCell> 
      <StyledTableCell align="left">{data.location}</StyledTableCell>
      <StyledTableCell align="left">{data.distanceFromCo}</StyledTableCell> 
      <StyledTableCell align="left">{data.powerBackup}</StyledTableCell> 
      <StyledTableCell align="left">{data.backupOwnership}</StyledTableCell> 
      <StyledTableCell align="left">{data.distanceFromLink}</StyledTableCell> 

      <StyledTableCell align="left">
        <Box
          sx={{
            color: getStatusColor(),
            backgroundColor: getStatusColor() + "44",
            padding: "3px 5px",
            borderRadius: 1,
            fontSize: 14,
            display: "inline-block",
            minWidth: 80,
            textAlign: "center",
          }}
        >
          {data.status}
        </Box>
      </StyledTableCell>

      <StyledTableCell align="right">
        <OrderActions data={data} />
      </StyledTableCell>
    </TableRow>
  );
};

export default TableItem;
